var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobListing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20851 3.31738L3.56801 4.95838L2.92751 4.31688L2.20801 5.03688L3.20801 6.03688L3.56751 6.38038L3.92701 6.03688L5.92701 4.03688L5.20851 3.31738ZM7.56801 4.17688V5.17688H14.068V4.17688H7.56801ZM5.20851 7.31738L3.56801 8.95788L2.92751 8.31788L2.20851 9.03638L3.20851 10.0364L3.56801 10.3799L3.92751 10.0364L5.92751 8.03638L5.20851 7.31738ZM7.56801 8.17688V9.17688H14.068V8.17688H7.56801ZM5.20851 11.3174L3.56801 12.9584L2.92751 12.3169L2.20801 13.0369L3.20801 14.0369L3.56751 14.3804L3.92701 14.0369L5.92701 12.0369L5.20851 11.3174ZM7.56801 12.1769V13.1769H14.068V12.1769H7.56801Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobListing);
export default __webpack_public_path__ + "static/media/JobListing.00d28d8913b865b56eb7e38b05fe2632.svg";
export { ForwardRef as ReactComponent };